import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class DrawAction extends AbstractProvidedClass {
    constructor(provider, shape) {
        super(provider);
        this.shape = shape;
    }

    finish() {
        this.elements.add(this.shape);
        this.actions.finish();
    }

    undo() {
        this.elements.delete([this.shape]);
    }

    redo() {
        this.elements.add(this.shape);
    }
}
